export default __webpack_public_path__ + "static/media/bl4.967e20ec.png";